import { Typography } from '@material-ui/core';
import { PortraitSharp } from '@material-ui/icons';
import { Dispatch, SetStateAction } from 'react';
import { Button } from '../../../../themes/components/Button';

interface TypeFooterRelatorios {
    regraGerar: boolean;
    regraImprimir: boolean;
    funcGerar: () => void;
    funcImprimir: () => void;
}

export const FooterRelatorios = (props: TypeFooterRelatorios) => {
    return (
        <div className="container-footer-relatorios">
            <div className="footer-novo-pedido-info-area">
            </div>
            <div className="footer-novo-pedido-botoes-area">
                {props.regraImprimir ? <Button onClick={props.funcImprimir} classBtn={"btn-footer-novo-pedido color-default"}>Imprimir</Button> : <></>}
                {props.regraGerar ? <Button onClick={props.funcGerar} classBtn={"btn-footer-novo-pedido color-default"}>Gerar Relatório</Button> : <></>}
            </div>
        </div>
    )
}